import { useState, useContext } from "react";
import { AuthContext } from "../context/auth-context";

export const Navigation = ({ home, isRtl }) => {
  const authContext = useContext(AuthContext);
  const [navLayout, setNavLayout] = useState(
    window.innerWidth > 780 ? "row" : "column"
  );
  const [selectedLanguage, setSelectedLanguag] = useState(
    authContext.currentLanguage
  );
  const getNavLayout = () => {
    if (isRtl && window.innerWidth > 780) {
      console.log("reached here");
      setNavLayout("row-revers");
    } else if (isRtl && window.innerWidth < 780) {
      setNavLayout("column");
    } else if (!isRtl && window.innerWidth < 780) {
      setNavLayout("column");
    } else if (!isRtl && window.innerWidth > 780) {
      setNavLayout("row");
    }
  };
  const changeLanguage = (lang) => {
    authContext.changeLanguage(lang);
    setSelectedLanguag(lang);
    getNavLayout();
  };
  return (
    <nav
      id="menu"
      className="navbar navbar-default navbar-fixed-top"
      style={{
        backgroundColor: "#081526",
      }}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="page-scroll" href="/#page-top">
            <img src={`/img/pcn.png`} className="logo_image" />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
          style={{ color: '#E0E0E0' }}
        >
          <ul
            className="nav navbar-nav navbar-right"
            style={{
              display: "flex",
              flexDirection: navLayout,
              color: '#E0E0E0'
            }}
          >
            <li>
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  paddingLeft: "2rem",
                  paddingTop: "1rem",
                }}
              > */}
              {/* {
                  !isRtl ? <label
                    className={isRtl ? "lang-label active" : "lang-label"}
                    onClick={() => changeLanguage("AR")}
                    style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans" }}
                  >
                    ع
                  </label>
                    : <label
                      className={!isRtl ? "lang-label active" : "lang-label"}
                      onClick={() => changeLanguage("EN")}
                      style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans" }}
                    >
                      En
                    </label>
                } */}
              {
                !isRtl ?
                  <a
                    // href="/#features"
                    onClick={() => changeLanguage("AR")}
                    className="page-scroll"
                    style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#7FB6FF', cursor: 'pointer', display: 'flex', gap: '5px', alignItems: 'baseline', marginTop: '4px' }}
                  >
                    ع {' '}<img src={`/img/icons/Vector (2).png`} style={{ width: "12px", height: '5.99px', cursor: 'pointer' }} />
                  </a> :
                  <a
                    // href="/#features"
                    onClick={() => changeLanguage("EN")}
                    className="page-scroll"
                    style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#7FB6FF', cursor: 'pointer', display: 'flex', gap: '5px', alignItems: 'baseline' }}
                  >
                    En {' '}<img src={`/img/icons/Vector (2).png`} style={{ width: "12px", height: '5.99px', }} />
                  </a>
              }
              {/* </div> */}
            </li>
            <li>
              <a
                href="/#features"
                className="page-scroll"
                style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#E0E0E0', display: 'flex', gap: '5px', alignItems: 'baseline' }}
              >
                <img src={`/img/icons/1.png`} style={{ width: "13.34px", height: '16px', }} />{' '}{isRtl ? "الميزات" : "Features"}
              </a>
            </li>
            <li>
              <a
                href="/#about"
                className="page-scroll"
                style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#E0E0E0', display: 'flex', gap: '5px', alignItems: 'baseline' }}
              >
                <img src={`/img/icons/2.png`} style={{ width: "13.03px", height: '13px', }} />{' '}{isRtl ? "حول الشركة" : "About"}
              </a>
            </li>
            <li>
              <a
                href="/#services"
                className="page-scroll"
                style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#E0E0E0', display: 'flex', gap: '5px', alignItems: 'baseline' }}
              >
                <img src={`/img/icons/3.png`} style={{ width: "10.34px", height: '14px', }} />{' '}{isRtl ? "الخدمات" : "Services"}
              </a>
            </li>
            <li>
              <a
                href="/#portfolio"
                className="page-scroll"
                style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#E0E0E0' }}
              >
                <img src={`/img/icons/4.png`} style={{ width: "16px", height: '14.16px', }} />{' '}{isRtl ? "المشاريع" : "Projects"}
              </a>
            </li>
            <li>
              <a
                href="/#news"
                className="page-scroll"
                style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#E0E0E0', display: 'flex', gap: '5px', alignItems: 'baseline' }}
              >
                <img src={`/img/icons/5.png`} style={{ width: "15.74px", height: '14px', }} />{' '}{isRtl ? "الاخبار" : "News"}
              </a>
            </li>
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li> */}
            <li>
              <a
                href="/#team"
                className="page-scroll"
                style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#E0E0E0', display: 'flex', gap: '5px', alignItems: 'baseline' }}
              >
                <img src={`/img/icons/6.png`} style={{ width: "20px", height: '11.8px', }} />{' '}{isRtl ? "فريقنا" : "Team"}
              </a>
            </li>
            <li>
              <a
                href="/#contact"
                className="page-scroll"
                style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#E0E0E0' }}
              >
                {isRtl ? "اتصل بنا" : "Contact"}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
